import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const MaterialDelivery: ITypeSpecificPolicy<types.MaterialDelivery> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy(),
    receivedDate: dateTimeFieldPolicy()
  }
};
